<template>
  <div class="registered-items-list-container registered-items-list-page--glass glass-tab-page">
    <BrucdcumHeader
      :breadcrumb="['Fixed Assets', 'Registered Items List']"
      :show-back-button="true"
      :back-fallback="backFallbackRoute"
    />

    <div class="glass-tab-view glass-tab-view--flush registered-items-list-glass-shell">
      <div class="glass-tab-view__content registered-items-list-page-stack">
        <div class="registered-items-list-header-block">
          <div class="registered-items-list-header-row">
            <div class="registered-items-list-header-row__text">
              <h2 class="registered-items-list-title">Registered Items List</h2>
              <p class="registered-items-list-subtitle">
                View registered fixed assets and current book values
              </p>
            </div>
            <div class="registered-items-list-header-actions">
              <SecondaryButton
                label="Export to CSV"
                icon="bi bi-download"
                @click="handleExportCsv"
              />
              <PrimaryButton
                label="Add a New Asset"
                icon="bi bi-plus-lg"
                @click="openNewAssetModal"
              />
            </div>
          </div>
        </div>

        <div class="registered-items-list-table-panel glass-tab-panel--nested">
          <h3 class="registered-items-list-table-heading">Registered items</h3>
          <div class="registered-items-list-table-section consultant-glass-table-section">
            <div class="consultant-glass-table-responsive consultant-glass-table-responsive--framed">
              <div class="consultant-glass-table-scroll-x">
                <table class="consultant-glass-table registered-items-list-table">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Asset Number</th>
                      <th>Account</th>
                      <th>Purchase Date</th>
                      <th>Purchase Price</th>
                      <th>Book value</th>
                      <th>Show history</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="sampleRegisteredItems.length === 0">
                      <td colspan="8" class="consultant-glass-table-no-records registered-items-list-no-records">
                        No registered items found.
                      </td>
                    </tr>
                    <template v-else>
                      <tr
                        v-for="(item, idx) in sampleRegisteredItems"
                        :key="item.assetNumber + idx"
                        class="consultant-glass-table-row registered-items-list-table-row"
                        :style="{ '--ril-row-delay': `${0.04 + Math.min(idx, 14) * 0.025}s` }"
                      >
                        <td>{{ item.item }}</td>
                        <td>{{ item.assetNumber }}</td>
                        <td>{{ item.account }}</td>
                        <td>{{ item.purchaseDate }}</td>
                        <td class="registered-items-list-amount-cell">{{ item.purchasePrice }}</td>
                        <td class="registered-items-list-amount-cell">{{ item.bookValue }}</td>
                        <td class="registered-items-list-history-cell">{{ item.showHistory }}</td>
                        <td></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Transition name="registered-items-list-modal-overlay">
      <div
        v-if="showNewAssetModal"
        class="registered-items-list-modal-overlay registered-items-list-modal-overlay--glass"
        @click.self="closeNewAssetModal"
      >
        <Transition name="registered-items-list-modal-panel" appear>
          <div
            v-if="showNewAssetModal"
            class="registered-items-list-modal-card registered-items-list-modal-card--glass"
            role="dialog"
            aria-modal="true"
            aria-labelledby="registered-items-new-asset-title"
            @click.stop
          >
            <div class="registered-items-list-modal-header registered-items-list-modal-header--glass">
              <h2 id="registered-items-new-asset-title" class="registered-items-list-modal-title">
                New Fixed Asset
              </h2>
              <button
                type="button"
                class="registered-items-list-modal-close-btn"
                aria-label="Close"
                title="Close"
                @click="closeNewAssetModal"
              >
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            </div>
            <div class="registered-items-list-modal-body registered-items-list-modal-body--glass">
              <NewFixedAsset embedded @cancel="closeNewAssetModal" @saved="closeNewAssetModal" />
            </div>
          </div>
        </Transition>
      </div>
    </Transition>
  </div>
</template>

<script>
import '../styles/RegisteredItemsList.css';
import '../styles/registered-items-list-glass.css';
import BrucdcumHeader from '@/components/BrucdcumHeader.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';
import NewFixedAsset from './NewFixedAsset.vue';

export default {
  name: 'RegisteredItemsList',
  components: {
    BrucdcumHeader,
    PrimaryButton,
    SecondaryButton,
    NewFixedAsset,
  },
  data() {
    return {
      showNewAssetModal: false,
      sampleRegisteredItems: [
        {
          item: 'Laptop',
          assetNumber: 'A-101',
          account: 'IT Equipment',
          purchaseDate: '2022-11-10',
          purchasePrice: '$1,200.00',
          bookValue: '$900.00',
          showHistory: 'View',
        },
        {
          item: 'Office Chair',
          assetNumber: 'A-102',
          account: 'Furniture',
          purchaseDate: '2022-12-01',
          purchasePrice: '$180.00',
          bookValue: '$150.00',
          showHistory: 'View',
        },
        {
          item: 'Projector',
          assetNumber: 'A-103',
          account: 'Office Equipment',
          purchaseDate: '2023-01-20',
          purchasePrice: '$500.00',
          bookValue: '$400.00',
          showHistory: 'View',
        },
      ],
    };
  },
  computed: {
    companyId() {
      return this.$route.params.id || this.$route.params.companyId;
    },
    backFallbackRoute() {
      const companyId = this.companyId || this.$route.params.id;
      return `/company/${companyId}/dashboard/company/fixed-assets/pending-items`;
    },
  },
  methods: {
    openNewAssetModal() {
      this.showNewAssetModal = true;
    },
    closeNewAssetModal() {
      this.showNewAssetModal = false;
    },
    handleExportCsv() {
      this.$toast?.info('Export to CSV coming soon!') || alert('Export to CSV coming soon!');
    },
  },
};
</script>
